<template>
  <div id="highlight">
    <top></top>
    <div class="highlight bg_wrap">
      <div class="container">
        <newTitle
          class="highlight_title"
          :title="lang === 'cn' ? '2026新亮点' : '2026 New Highlights'"
        ></newTitle>
        <div class="highlight_content" v-html="richtext"></div>
        <div class="highlight_list">
          <p class="highlight_list_title">
            {{ lang === "cn" ? "同期活动一览" : "Concurrent Events Overview" }}
          </p>
          <div>
            <div v-for="(item, index) in activityList" :key="index">
              <div
                class="highlight_list_content"
                v-if="lang === 'cn' ? item.name : item.name_en"
              >
                <img :src="item.icon" alt="" />
                <p>
                  {{ lang === "cn" ? item.name : item.name_en }}
                </p>
                <div>
                  <div
                    class="highlight_list_content_item"
                    v-for="(item2, index2) in item.activity"
                    :key="index2"
                  >
                    <p v-if="lang === 'cn' ? item2.name : item2.name_en">
                      {{ lang === "cn" ? item2.name : item2.name_en
                      }}<em v-if="item2.is_new == 1">New</em>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <bottom></bottom>
  </div>
</template>

<script>
import top from "@/components/top.vue";
import bottom from "@/components/bottom.vue";
import newTitle from "@/components/new_title.vue";
import { webAbout, getHighlightActivity } from "@/api/api";
export default {
  components: {
    top,
    bottom,
    newTitle,
  },
  data() {
    return {
      type: "",
      lang: "",
      richtext: "",
      activityList: [],
    };
  },
  created() {
    this.lang = this.$language;
    this.type = this.$route.query.type;
    this.getRichtext();
    this.getActivity();
  },
  methods: {
    async getRichtext() {
      const res = await webAbout({
        type: this.type,
      });
      if (res.code == 1) {
        if (this.lang === "cn") {
          this.richtext = res.data.lists[0].content;
        } else if (this.lang === "en") {
          this.richtext = res.data.lists[0].content_en;
        }
      } else {
        this.$message.error(res.msg);
      }
    },
    async getActivity() {
      const res = await getHighlightActivity();
      if (res.code == 1) {
        this.activityList = res.data.lists;
      } else {
        this.$message.error(res.msg);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.highlight_title {
  margin-bottom: 30px;
}
.highlight_content {
  margin-bottom: 30px;
  white-space: pre-wrap;
  overflow-wrap: break-word;
  word-break: keep-all;
  /deep/ img {
    max-width: 100% !important;
    height: auto !important;
    object-fit: contain;
    display: block;
    margin: 0 auto;
  }
}
.highlight_list {
  .highlight_list_title {
    color: #0074bf;
    font-weight: 600;
    text-align: center;
    font-size: 28px;
    margin-bottom: 20px;
  }
  > div {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 5px;
    .highlight_list_content {
      width: 252px;
      height: 320px;
      background-image: url("../../assets/activity_border.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      box-sizing: border-box;
      padding-top: 20px;
      overflow: hidden;
      img {
        height: 36px;
        width: 36px;
        display: block;
        margin: 0 auto;
      }
      > p {
        color: #0074bf;
        text-align: center;
        font-size: 18px;
        font-weight: 500;
        margin-top: 10px;
        margin-bottom: 20px;
        box-sizing: border-box;
        padding: 0 10px;
        line-height: 22px;
      }
      > div {
        overflow-y: scroll;
        max-height: 200px;
        &::-webkit-scrollbar {
          display: none;
        }
        scrollbar-width: none;
        -ms-overflow-style: none;
        .highlight_list_content_item {
          margin-bottom: 10px;
          p {
            box-sizing: border-box;
            padding: 0 10px 0 24px;
            color: #333;
            font-weight: 500;
            position: relative;
            line-height: 20px;
            margin-bottom: 4px;
            > em {
              color: red;
              font-size: 14px;
              font-weight: 700;
              margin-left: 10px;
            }
            &::before {
              content: "";
              width: 10px;
              height: 10px;
              border-radius: 50%;
              background: #39c665;
              position: absolute;
              left: 10px;
              top: 4px;
            }
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 1280px) {
  .highlight_content {
    width: 100%;
  }
  .highlight_list {
    .highlight_list_title {
      font-size: 20px;
    }
    > div {
      justify-content: space-around;
    }
  }
}

@media only screen and (max-width: 767px) {
  .highlight_content {
    width: 100%;
  }
  .highlight_list {
    .highlight_list_title {
      font-size: 20px;
    }
    > div {
      display: block;
      .highlight_list_content {
        margin: 0 auto 20px;
      }
    }
  }
}
</style>